import { Component } from '@angular/core';
import { CookiesHandlingService } from '$modules/pages/cookies-settings/services/cookies-handling.service';

@Component({
  selector: 'app-cookies-accept-popup',
  templateUrl: './cookies-accept-popup.component.html',
  styleUrls: ['./cookies-accept-popup.component.scss'],
})
export class CookiesAcceptPopupComponent {
  public readonly cookieSettingsPath = this.cookiesService.cookieSettingsPath;
  public readonly isPopupNeeded$ = this.cookiesService.isDecisionNotMade$;
  constructor(private cookiesService: CookiesHandlingService) {}

  public accept(): void {
    this.cookiesService.acceptAll();
  }

  public decline(): void {
    this.cookiesService.declineAll();
  }
}
